import { Skeleton } from "antd";

export default function ReviewLoading() {
  return (
    <>
      {[1, 2, 3].map((item) => (
        <div
          key={item}
          className="flex bg-white rounded-lg border border-gray-200 p-6"
        >
          <div className="w-full">
            {/* Avatar and Rating Skeleton */}
            <div className="flex items-start gap-4 mb-4">
              <Skeleton.Avatar active size={56} />
              <div className="flex-1">
                <Skeleton.Input active size="small" className="!w-32 mb-2" />
                <Skeleton.Input active size="small" className="!w-24" />
              </div>
            </div>

            {/* Comment Text Skeleton */}
            <div className="space-y-2">
              <Skeleton.Input active size="small" className="!w-full" />
              <Skeleton.Input active size="small" className="!w-full" />
              <Skeleton.Input active size="small" className="!w-3/4" />
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
